import React from "react";
import DashboardDropdown from "components/DashboardDropdown";
import { EVENTS_DROPDOWN_FILTERS } from "../data/audience-insights-data";

const ProjectFilters = ({
  filterType = "none",
  updateFilterHandler = () => {},
  filterBy = "Registrations",
}) => {
  return (
    <div>
      <div className="d-flex flex-column align-items-start flex-md-row align-items-md-end gap-2">
        {filterType === "all" && (
          <div className="d-flex gap-3 align-items-center justify-content-end ms-3">
            <div className="fs-6 text-black">Filter By</div>
            <div className="dropdown bg-white border border-1 rounded-3 px-3 py-2">
              <DashboardDropdown
                constantFilterOption={EVENTS_DROPDOWN_FILTERS}
                handleDropdownChange={updateFilterHandler}
                type={filterBy}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectFilters;
